import { create } from "zustand";
import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

interface CreatePasskeyStore {
  isOpen: boolean;
  isDismissedByUser: Record<number, boolean>;
  open: (userId: number) => void;
  dismiss: (userId: number) => void;
  reset: () => void;
}

export const useCreatePasskeyStore = create<CreatePasskeyStore>()(
  persist(
    immer((set) => ({
      isOpen: false,
      isDismissedByUser: {},
      open(userId: number) {
        set((state) => {
          if (!state.isDismissedByUser[userId]) {
            state.isOpen = true;
          }
        });
      },
      dismiss(userId: number) {
        set((state) => {
          state.isOpen = false;
          state.isDismissedByUser[userId] = true;
        });
      },
      reset() {
        set((state) => {
          state.isOpen = false;
        });
      },
    })),
    {
      name: "create-passkey-store",
      partialize: (state) => ({
        isDismissedByUser: state.isDismissedByUser,
      }),
    }
  )
);
